import { render, staticRenderFns } from "./ShortVideoStar.vue?vue&type=template&id=2efb4729&scoped=true"
import script from "./ShortVideoStar.vue?vue&type=script&lang=js"
export * from "./ShortVideoStar.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoStar.vue?vue&type=style&index=0&id=2efb4729&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb4729",
  null
  
)

export default component.exports